module.exports = __webpack_public_path__ + "static/media/48.ba7753f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/48.svg
// module id = 155
// module chunks = 0